<template>
  <td :colspan="colspan">
    <span v-show="!editing">
      <!-- <img v-if="iconBool" class="media-left" :src="path + option.icon" height="25" width="25" /> -->
      {{ value | prettyDate }}</span
    >
    <span v-show="editing">
      <div v-if="type != 'select'">
        <b-input :value="value" :type="type" size="is-small" @input="$emit('input', $event)" class="form-control" />
      </div>
      <div v-else>
        <b-dropdown :value="value" aria-role="list" @input="emitValue">
          <button class="button" type="button" slot="trigger">
            <template v-if="typeof object != 'object' || object == null">
              <span>Kies hier!</span>
            </template>
            <template v-else>
              <img v-if="iconBool" class="media-left" :src="path + object.icon" height="25" width="25" />
              <div v-if="showName">
                {{ object.name }}
              </div>
              <div v-else>
                {{ object.code }}
              </div>
            </template>
            <b-icon icon="menu-down"></b-icon>
          </button>

          <b-dropdown-item v-for="option in activeList" :value="option" :key="option.id" aria-role="listitem">
            <div class="media">
              <img v-if="iconBool" class="media-left" :src="path + option.icon" height="25" width="25" />
              <div class="media-content">
                <!-- <h3>Public</h3> -->
                <div v-if="!tooltip">
                  {{ option.name }}
                </div>
                <div v-else>
                  <!-- import tooptip -->
                  <b-tooltip animated :label="option.name" multilined>
                    {{ option.code }}
                  </b-tooltip>
                </div>
              </div>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </span>
  </td>
</template>

<script>
export default {
  filters: {
    prettyDate: function(value) {
      if (!value) return ''
      if (typeof value == 'string' && value.includes('20') && value.includes('T') && value.includes(':')) {
        const d = new Date(value)
        return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`
      }
      return value
    },
    prettyName: function(value) {
      const obj = this.bsc.find(o => o.code == value)
      return obj.name
    }
  },
  props: {
    value: { required: true },
    editing: { type: Boolean, required: true },
    colspan: { type: String, default: '1', required: false },
    type: { type: String, default: 'text' },
    iconBool: { type: Boolean, default: false },
    dataSelect: {
      type: Array
    },
    showName: { type: Boolean, default: false },
    tooltip: { type: Boolean, default: false }
  },
  data() {
    return {
      path: '../../../static/icons/',
      chosen: null,
      object: null,
      init: false
    }
  },
  computed: {
    activeList: function() {
      //return this.item == 'bsc' ? this.bsc : this.fireRating
      if (this.dataSelect != []) if (typeof this.dataSelect[0] != 'string') return this.dataSelect
      {
        const newArrayOfObjects = []
        for (let i = 0; i < this.dataSelect.length; i++) {
          newArrayOfObjects.push({ id: i, code: this.dataSelect[i], name: this.dataSelect[i] })
        }
        return newArrayOfObjects
      }
    }
  },

  updated() {
    this.valueToObject()
  },
  methods: {
    emitValue: function(e) {
      this.$emit('input', e.code)
    },
    valueToObject() {
      if (this.type != 'text') {
        if (this.dataSelect !== undefined) {
          if (typeof this.value == 'string') {
            const obj = this.activeList.find(o => o.code == this.value)
            if (obj != undefined) {
              this.object = obj
            } else {
              this.object = this.value
            }
          } else {
            this.object = this.value
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.form-control {
  height: 24px;
  .is-small.input {
    padding: 0px;
    padding-left: 6px;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/editable.vue